import {createContext} from 'react'

const HistoriaClinicaInicialContext = createContext()

export default HistoriaClinicaInicialContext